import type { PuzzleTemplateId } from "../../types/domain";

export interface ValidationResult {
  success: boolean;
  score: number;
  feedback: string;
  details?: Record<string, number | string | boolean>;
}

export interface PuzzleCore<
  TConfig extends Record<string, unknown>,
  TInstance,
  TSubmission extends Record<string, unknown>,
> {
  id: Exclude<PuzzleTemplateId, "coming-soon">;
  schemaVersion: number;
  generate(config: TConfig, seed: number): TInstance;
  validate(
    config: TConfig,
    instance: TInstance,
    submission: TSubmission,
  ): ValidationResult;
}

export function seededRandom(seed: number) {
  let value = seed >>> 0;
  return () => {
    value += 0x6d2b79f5;
    let next = value;
    next = Math.imul(next ^ (next >>> 15), next | 1);
    next ^= next + Math.imul(next ^ (next >>> 7), next | 61);
    return ((next ^ (next >>> 14)) >>> 0) / 4_294_967_296;
  };
}

export function randomBetween(
  random: () => number,
  min: number,
  max: number,
) {
  return min + random() * (max - min);
}
